import { render, staticRenderFns } from "./listuser.vue?vue&type=template&id=8b2983b8&"
import script from "./listuser.vue?vue&type=script&lang=js&"
export * from "./listuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports